<template>
  <v-ons-page @show="showPage()" modifier="white notoolbar">

    <div class="content content--perfwelcome">

        <header>
          <img src="../assets/imgs/logo_app@2x.png" />
          <h1>Vendez votre récolte au bon prix</h1>
          <p>Retrouvez les prix de vos coops et négoces sur votre téléphone</p>
        </header>
        
        <section v-if="! hideLogin">
          <p>
            <a :href="$apiDomain + '/storelink'">
            <v-ons-button modifier="large--cta perflarge" @click="inscription">
              S'inscrire
            </v-ons-button>
            </a>
          </p>
          <p class="content--perfwelcome__sep">ou</p>
          <p>
            <a :href="$apiDomain + '/storelink'">
            <v-ons-button modifier="outline perflarge" @click="login">
              J'ai déjà un compte
            </v-ons-button>
            </a>
          </p>
        </section>

      </div>

    <v-ons-modal modifier="bottom" :visible="hideLogin">
      <p style="text-align: center">
        <v-ons-progress-circular :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
      </p>
    </v-ons-modal>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import AppParamsPerso from './ParamsPerso.vue';
import AppLoginEmail from './LoginEmail.vue';

export default {
  mixins: [mixinsCommons],
  props: ['pageStack'],
  data() {
    return {
      hideLogin: true,
      initPath: '',
      idMulti: '',
    }
  },
  computed: {
    isWebappMobile() {
      return ! this.$ons.platform.isWebView() && (this.$ons.platform.isAndroid() || this.$ons.platform.isIOS())
    }
  },
  methods: {
    inscription(event) {
      if (this.isWebappMobile){
        return;
      } else {
        this.pageStack.push(AppParamsPerso);
        this.sendTrackEvent('inscription');
        event.preventDefault();
      }
    },
    login(event) {
      if (this.isWebappMobile){
        return;
      } else {
        this.pageStack.push(AppLoginEmail);
        event.preventDefault();
      }
    },
    showPage(){
      if(this.idMulti){
        this.$emit('change-multi', { idMulti: this.idMulti });
      }
    }
  },
  created() {
    if(this.initPath == 'login'){
      this.pageStack.push(AppLoginEmail);
    } else if(this.initPath == 'inscription'){
      this.pageStack.push(AppParamsPerso);
    }
  }
};
</script>

<style>
.content--perfwelcome header {
  background-image: url('../assets/imgs/accueil_bg@2x.png');
}
.modal--bottom .modal__content {
  vertical-align: bottom;
}
</style>